import { api } from '@/shared/api/client';
import type { Page } from '@/entities/subscription/api';
import type { DomainEvent, LedgerOperation, OperationType } from './types';

function toQuery(params: Record<string, string | number | undefined>) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export const ledgerApi = {
  listOperations: (
    subscriptionId: string,
    params: { participant_id?: string; type?: OperationType; limit?: number; offset?: number } = {},
  ) =>
    api.get<Page<LedgerOperation>>(
      `/api/v1/subscriptions/${subscriptionId}/operations${toQuery(params)}`,
    ),

  listHistory: (
    subscriptionId: string,
    params: { limit?: number; offset?: number } = {},
  ) =>
    api.get<Page<DomainEvent>>(
      `/api/v1/subscriptions/${subscriptionId}/history${toQuery(params)}`,
    ),
};
